import { useState, } from "react";
import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkInsertStandardUnitPriceSearchDialog from "../dialogTypes/TkInsertStandardUnitPriceSearchDialog";

function TkInsertStandardUnitPriceSearchButton ( props ) {

    const { id, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const onOpen = () => {
        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    return (
        <>
            <CreateRecordButtonLayout id={id+"excelUpload-button"} onClick={onOpen} createButtonName={"insertCodeSearch"}{...others} />
            <TkInsertStandardUnitPriceSearchDialog
                id={id+"excelUpload-search-dialog"}
                formId={id+"excelUpload-search-form"}
                open={open}
                onClose={onClose}
            />
        </>

    );
}

export default TkInsertStandardUnitPriceSearchButton;

